import { useState } from "react";
import { C, uid, fmt, Btn, Input, Select, Textarea, StatCard, Tabs, useIsMobile } from "./ui";
import { TIPOS_ZONA } from "./Zonas";
import { MaquinariaPanel } from "./Maquinaria";
import { toast } from "../services/toast";

const iconZona = (z) => (z && TIPOS_ZONA[z.tipo]?.icon) || "🏠";

export const TIPOS_TAREA = [
  "Vacunación", "Desparasitación", "Entore", "Parición", "Destete",
  "Análisis / Diagnóstico", "Recorrida", "Aplicación sanitaria", "Otro",
];
const ICON_TAREA = {
  "Vacunación":"💉", "Desparasitación":"🪱", "Entore":"🐂", "Parición":"🐮",
  "Destete":"🍼", "Análisis / Diagnóstico":"🔬", "Recorrida":"🚜",
  "Aplicación sanitaria":"🧴", "Otro":"📌",
};

const hoyStr = () => new Date().toISOString().slice(0, 10);
const diasHasta = (fechaISO) => {
  if (!fechaISO) return null;
  const ms = new Date(fechaISO + "T12:00:00").getTime() - new Date().setHours(12, 0, 0, 0);
  return Math.round(ms / 86400000);
};
const textoFecha = (d) => {
  if (d === 0) return "Hoy";
  if (d === 1) return "Mañana";
  if (d === -1) return "Ayer";
  if (d < 0) return `Hace ${-d} días`;
  return `En ${d} días`;
};

export function CalendarioPanel({
  tareas, potreros, zonas = [], onUpdate,
  maquinas = [], empleados = [], onUpdateMaquinas, onUpdateEmpleados,
  user, profile, tareasState, empleadosState, maquinariasState
}) {
  const isMobile = useIsMobile();
  const [tabActivo, setTabActivo] = useState("calendario");
  const [show, setShow]       = useState(false);
  const [tipo, setTipo]       = useState(TIPOS_TAREA[0]);
  const [titulo, setTitulo]   = useState("");
  const [fecha, setFecha]     = useState(hoyStr());
  const [objetivo, setObjetivo] = useState("");   // "" | "pot:ID" | "zona:ID"
  const [maquinaId, setMaquinaId] = useState("");
  const [empleadoId, setEmpleadoId] = useState("");
  const [obs, setObs]         = useState("");
  const [confirmar, setConfirmar] = useState(null);

  const guardar = async () => {
    if (!fecha) return;
    const potreroId = objetivo.startsWith("pot:") ? objetivo.slice(4) : "";
    const zonaId    = objetivo.startsWith("zona:") ? objetivo.slice(5) : "";
    try {
      await tareasState.createTarea({
        tipo, titulo: titulo.trim() || tipo, fecha,
        potrero_id: potreroId, zona_id: zonaId, maquina_id: maquinaId, empleado_id: empleadoId,
        estado: "pendiente", obs,
      });
      setShow(false); setTitulo(""); setObs(""); setObjetivo(""); setFecha(hoyStr()); setTipo(TIPOS_TAREA[0]);
      setMaquinaId(""); setEmpleadoId("");
      toast.success("Tarea agendada.");
    } catch (e) {
      console.error("Error creando tarea:", e);
      toast.error("No se pudo crear la tarea: " + (e.message || "error"));
    }
  };
  const toggle = async (id) => {
    const t = tareas.find(x => x.id === id);
    if (t) {
      try {
        await tareasState.updateTarea(id, { estado: t.estado === "hecha" ? "pendiente" : "hecha" });
      } catch (e) {
        console.error("Error actualizando tarea:", e);
      }
    }
  };
  const eliminar = async (id) => {
    try {
      await tareasState.deleteTarea(id);
    } catch (e) {
      console.error("Error eliminando tarea:", e);
    }
  };

  const pendientes = tareas.filter(t => t.estado !== "hecha");
  const hechas     = tareas.filter(t => t.estado === "hecha");
  const vencidas   = pendientes.filter(t => diasHasta(t.fecha) < 0).sort((a,b)=>a.fecha.localeCompare(b.fecha));
  const semana     = pendientes.filter(t => { const d = diasHasta(t.fecha); return d >= 0 && d <= 7; }).sort((a,b)=>a.fecha.localeCompare(b.fecha));
  const proximas   = pendientes.filter(t => diasHasta(t.fecha) > 7).sort((a,b)=>a.fecha.localeCompare(b.fecha));

  const Tarea = ({ t }) => {
    const d = diasHasta(t.fecha);
    const hecha = t.estado === "hecha";
    const pot = potreros.find(p => p.id === t.potreroId);
    const zona = zonas.find(z => z.id === t.zonaId);
    const lugar = pot ? `🗺 ${pot.nombre}` : zona ? `${iconZona(zona)} ${zona.nombre}` : "todo el campo";
    const col = hecha ? C.muted : d < 0 ? C.danger : d <= 7 ? "#9A7B1E" : C.tierra;
    return (
      <div style={{ display:"flex", alignItems:"center", gap:11, background:C.white, borderRadius:10,
        padding:"10px 13px", marginBottom:6, border:`1px solid ${d<0&&!hecha?"#E09090":C.arenaDark}` }}>
        <input type="checkbox" checked={hecha} onChange={()=>toggle(t.id)}
          style={{ width:18, height:18, cursor:"pointer", flexShrink:0, accentColor:C.pasto }}/>
        <span style={{ fontSize:20, flexShrink:0, opacity:hecha?0.5:1 }}>{ICON_TAREA[t.tipo]||"📌"}</span>
        <div style={{ flex:1, minWidth:0 }}>
          <div style={{ fontSize:14, fontWeight:600, color:hecha?C.muted:C.tierra,
            textDecoration:hecha?"line-through":"none" }}>{t.titulo}</div>
          <div style={{ fontSize:11, color:C.muted }}>
            {t.tipo} · {lugar}{t.obs?` · ${t.obs}`:""}
          </div>
        </div>
        <div style={{ textAlign:"right", flexShrink:0 }}>
          <div style={{ fontSize:12, fontWeight:600, color:col }}>{hecha?"Hecha":textoFecha(d)}</div>
          <div style={{ fontSize:10, color:C.muted, fontFamily:"monospace" }}>{fmt(t.fecha)}</div>
        </div>
        {confirmar===t.id ? (
          <div style={{ display:"flex", gap:4, flexShrink:0 }}>
            <button onClick={()=>{eliminar(t.id);setConfirmar(null);}} style={{...btnX, background:C.danger, color:"#fff", borderColor:C.danger}}>Sí</button>
            <button onClick={()=>setConfirmar(null)} style={btnX}>No</button>
          </div>
        ) : (
          <button onClick={()=>setConfirmar(t.id)} title="Eliminar" style={{...btnX, color:C.danger, borderColor:"#E0909055"}}>✕</button>
        )}
      </div>
    );
  };

  const Grupo = ({ label, items, color }) => items.length===0 ? null : (
    <div style={{ marginBottom:18 }}>
      <div style={{ fontSize:11, fontFamily:"monospace", textTransform:"uppercase", letterSpacing:"0.08em",
        color: color||C.muted, marginBottom:8, fontWeight:600 }}>{label} · {items.length}</div>
      {items.map(t => <Tarea key={t.id} t={t}/>)}
    </div>
  );

  const enMaquinaria = tabActivo === "maquinaria";

  return (
    <div style={{ flex:1, overflowY:"auto", background:C.fondo }}>
      <div style={{ padding: isMobile?"14px 14px":"20px 24px", maxWidth:820, margin:"0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 18 }}>
          <div>
            <div style={{ fontFamily:"serif", fontSize:22, color:C.tierra, fontWeight:600, marginBottom:4 }}>
              {enMaquinaria ? "Maquinaria" : "Calendario sanitario"}
            </div>
            <div style={{ fontSize:13, color:C.muted }}>
              {enMaquinaria
                ? "Máquinas del campo y sus mantenimientos."
                : "Agendá vacunaciones, desparasitaciones, entore, parición y demás tareas. Marcá las hechas."}
            </div>
          </div>
          {/* Tabs espera [{id,label}] y devuelve el id, como en Economía/Fardos/
              Gestión. Pasándole strings, t.label quedaba undefined (botones en
              blanco) y onChange(undefined) caía siempre en "maquinaria", sin
              forma de volver al calendario. */}
          <Tabs
            tabs={[{ id: "calendario", label: "📅 Calendario" }, { id: "maquinaria", label: "🚜 Maquinaria" }]}
            active={tabActivo}
            onChange={setTabActivo}
          />
        </div>

        {enMaquinaria ? (
          <MaquinariaPanel maquinarias={maquinas} onUpdate={onUpdateMaquinas} user={user} profile={profile} />
        ) : (
        <>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))", gap:10, marginBottom:18 }}>
          <StatCard val={vencidas.length} label="vencidas" color={vencidas.length?C.danger:C.muted}/>
          <StatCard val={semana.length}   label="esta semana" color="#9A7B1E"/>
          <StatCard val={pendientes.length} label="pendientes" color={C.tierra}/>
          <StatCard val={hechas.length}   label="hechas" color={C.pasto}/>
        </div>

        <div style={{ display:"flex", justifyContent:"flex-end", marginBottom:14 }}>
          <Btn variant="primary" onClick={()=>setShow(v=>!v)}>{show?"Cancelar":"+ Nueva tarea"}</Btn>
        </div>

        {show && (
          <div style={{ background:C.white, borderRadius:12, padding:16, marginBottom:16, border:`1px solid ${C.arenaDark}` }}>
            <div style={{ display:"grid", gridTemplateColumns: isMobile?"1fr":"1fr 1fr", gap:"0 12px" }}>
              <Select label="Tipo" value={tipo} onChange={setTipo} options={TIPOS_TAREA}/>
              <Input label="Fecha" value={fecha} onChange={setFecha} type="date"/>
              <Input label="Título (opcional)" value={titulo} onChange={setTitulo} placeholder="Ej: Vacuna aftosa 2da dosis"/>
              <Select label="Asignar a (opcional)" value={objetivo} onChange={setObjetivo}
                options={[
                  {v:"",l:"— Todo el campo —"},
                  ...potreros.map(p=>({v:`pot:${p.id}`, l:`🗺 ${p.nombre}`})),
                  ...zonas.map(z=>({v:`zona:${z.id}`, l:`${iconZona(z)} ${z.nombre}`})),
                ]}/>
              <Select label="Máquina (opcional)" value={maquinaId} onChange={setMaquinaId}
                options={[{v:"",l:"— Ninguna —"}, ...maquinas.map(m=>({v:m.id,l:m.nombre}))]}/>
              <Select label="Empleado (opcional)" value={empleadoId} onChange={setEmpleadoId}
                options={[{v:"",l:"— Sin asignar —"}, ...empleados.map(e=>({v:e.id,l:e.nombre}))]}/>
            </div>
            <Textarea label="Notas" value={obs} onChange={setObs} rows={2}/>
            <Btn variant="primary" onClick={guardar} disabled={!fecha} style={{ width:"100%" }}>Agendar tarea</Btn>
          </div>
        )}

        {tareas.length===0 && !show && (
          <div style={{ textAlign:"center", padding:"40px 20px", color:C.muted }}>
            <div style={{ fontSize:36, marginBottom:10 }}>📅</div>
            <div style={{ fontSize:13 }}>Sin tareas agendadas. Creá la primera con "+ Nueva tarea".</div>
          </div>
        )}

        <Grupo label="⚠ Vencidas" items={vencidas} color={C.danger}/>
        <Grupo label="Esta semana" items={semana} color="#9A7B1E"/>
        <Grupo label="Próximas" items={proximas}/>
        <Grupo label="✓ Hechas" items={hechas}/>
        </>
        )}
      </div>
    </div>
  );
}

const btnX = {
  background: C.arena, border: `1px solid ${C.arenaDark}`, borderRadius: 6,
  padding: "6px 9px", fontSize: 12, cursor: "pointer", color: C.tierra, fontFamily: "monospace", flexShrink: 0,
};
